<template>
	<div style="width: 90%;">
		<div class="container_body" style="margin-bottom: 30px;">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品id" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsId" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.isDiscounts" placeholder="请选择">
							<el-option key="0" label="未生效" :value="0">未生效</el-option>
							<el-option key="1" label="生效中" :value="1">生效中</el-option>
							<el-option key="2" label="已失效" :value="2">已失效</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.auditStatus" placeholder="请选择">
							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="已通过" :value="1">已通过</el-option>
							<el-option key="2" label="已驳回" :value="2">已驳回</el-option>
						</el-select>
					</el-form-item>


					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<!-- <el-button type="primary" @click="dialogVisibleFun()">新增商品</el-button> -->
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						<el-button type="primary" @click="dialogChuxiao()">申请促销</el-button>
					</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="promtion.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column prop="goodsId" label="商品ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="supplierName" label="供应商名称" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="isDh" label="商品类别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDh==1">兑换产品</p>
					<p v-if="scope.row.isDh==0">首页产品</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="isDiscounts" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDiscounts==0">未生效</p>
					<p v-if="scope.row.isDiscounts==1">生效中</p>
					<p v-if="scope.row.isDiscounts==2">已失效</p>
				</template>
			</el-table-column>
			<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.authStatus==0">未审核</p>
					<p v-if="scope.row.authStatus==1">已通过</p>
					<p v-if="scope.row.authStatus==2">已驳回</p>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="isDiscounts" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDiscounts==true">已生效</p>
					<p v-if="scope.row.isDiscounts==false">未生效</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="price" label="价格/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="costPrice" label="成本价" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="discountPrice" label="折扣价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="marketPrice" label="市场价/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="discountStartDatetime" label="开始时间" sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="discountEndDatetime" label="结束时间" sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<!-- 　<el-button v-if="scope.row.authStatus==0" size="small" type="text"
						@click="cloudShenhe(scope.row.id)">审核</el-button> -->
					<el-button  size="small" type="text" @click="seeDetail(scope.row.id)">查看详情</el-button>
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="promtion.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="promtion.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 申请促销弹窗 -->
		<el-dialog style="float:rigin" title="申请促销" :closeOnClickModal="false" :visible.sync="dialogChuciao" :close-on-click-modal="false"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="申请商品">
						<el-input type="text" style="width: 70%;margin-right: 20px;" clearable
							v-model="currentRow.goodsName" placeholder="请去选择商品" />
						<el-button type="primary" @click="gotoXz">去选择</el-button>
					</el-form-item>
					<div>
						<el-form-item label="零售价格(￥)" class="redItem">
							<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="currentRow.price" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣比例" class="redItem" style="width: 50%;">
							<el-input type="number" oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								@input="changePrice" v-model="storeGoodsInfo.discountRate" placeholder="请输入折扣比例" />
						</el-form-item>
						<el-form-item label="折扣价格" class="redItem" style="width: 50%;">
							<el-input type="number" oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								v-model="storeGoodsInfo.discountPrice" placeholder="请输入折扣价格" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣份数" class="redItem" style="width: 50%;">
							<el-input type="number" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.stock" placeholder="请输入份数" />
						</el-form-item>
						<el-form-item label="限购份数" class="redItem" style="width: 50%;">
							<el-input type="number" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.quantityLimit" placeholder="请输入份数 (0默认不限购)" />
							<!-- <span>(0默认不限购)</span> -->
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开始日期" class="redItem" style="width: 50%;">
							<el-date-picker v-model="storeGoodsInfo.discountStartDatetime"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期" class="redItem" style="width: 50%;">
							<el-date-picker v-model="storeGoodsInfo.discountEndDatetime"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="申请说明" class="redItem">
							<el-input type="textarea" size="small" width="100" :autosize="{ minRows: 3, maxRows: 6}"
								v-model="storeGoodsInfo.remark" placeholder="请输入申请说明" />
						</el-form-item>
					</div>
				</el-form>
				<el-dialog width="60%" title="选择商品" :visible.sync="innerVisible" append-to-body :close-on-click-modal="false">
					<el-form :inline="true" :model="goodsearch" class="demo-form-inline">
						<el-form-item label="商品Id">
							<el-input v-model="goodsearch.goodsId" placeholder="商品Id"></el-input>
						</el-form-item>
						<el-form-item label="商品名称">
							<el-input v-model="goodsearch.goodsName" placeholder="商品名称"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSubmit">查询</el-button>
						</el-form-item>
					</el-form>
					<el-table :data="tableData.list" border style="width: 100%" highlight-current-row
						@row-click="singleElection" v-loading="loading" max-height='650'>
						<el-table-column align="center" width="55" label="选择">
							<template slot-scope="scope">
								<!-- 可以手动的修改label的值，从而控制选择哪一项 -->
								<el-radio class="radio" v-model="templateSelection"
									:label="scope.row.id">&nbsp;</el-radio>
							</template>
						</el-table-column>
						<el-table-column prop="goodsId" label="商品id" align="center">
						</el-table-column>
						<el-table-column prop="goodsName" label="商品名称" align="center">
						</el-table-column>
						<el-table-column prop="images" label="商品图片" align="center">
							<template slot-scope="scope">
								<img :src="scope.row.images" alt="" style="width: 45px;height: 45px;">
							</template>
						</el-table-column>
					</el-table>
					<el-pagination style="margin: 20px 0px 20px;" background :current-page="tableData.pageNum"
						@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
						:total="tableData.total" @size-change="handleSizeChange">
					</el-pagination>
					<div style="text-align: center;margin-top: 30px">
						<el-button @click="innerVisible = false">取 消</el-button>
						<!-- <el-button  type="primary" @click="bohui">驳 回</el-button> -->
						<el-button type="primary" @click="sure">确 认</el-button>
					</div>
				</el-dialog>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogChuciao = false">取 消</el-button>
				<!-- <el-button  type="primary" @click="bohui">驳 回</el-button> -->
				<el-button type="primary" @click="confirm">申请促销</el-button>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" title="申请促销详情" :closeOnClickModal="false" :visible.sync="dialogDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="申请商品">
						<el-input type="text" disabled style="width: 70%;margin-right: 20px;" clearable
							v-model="Datails.goodsName" placeholder="请去选择商品" />
						<!-- <el-button type="primary" @click="gotoXz">去选择</el-button> -->
					</el-form-item>
					<div>
						<el-form-item label="零售价格(￥)" class="redItem">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="Datails.price" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣比例" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								 v-model="Datails.discountRate" placeholder="请输入折扣比例" />
						</el-form-item>
						<el-form-item label="折扣价格" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								v-model="Datails.discountPrice" placeholder="请输入折扣价格" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.stock" placeholder="请输入份数" />
						</el-form-item>
						<el-form-item label="限购份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.quantityLimit" placeholder="请输入份数 (0默认不限购)" />
							<!-- <span>(0默认不限购)</span> -->
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开始日期"  class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountStartDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期" class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountEndDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="申请说明" class="redItem">
							<el-input type="textarea" disabled size="small" width="100" :autosize="{ minRows: 3, maxRows: 6}"
								v-model="Datails.remark" placeholder="请输入申请说明" />
						</el-form-item>
					</div>
				</el-form>
				
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogDatil = false">取 消</el-button>
				<!-- <el-button  type="primary" @click="bohui">驳 回</el-button> -->
				<!-- <el-button type="primary" @click="confirm">申请促销</el-button> -->
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				searchInfo: {},
				promtion: {},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				dialogDatil:false,
				Datails:{},
				dialogChuciao: false, //申请促销弹窗
				innerVisible: false, // 选择促销商品弹窗
				storeGoodsInfo: {},
				// value1: '',
				goodsearch: {},
				templateSelection: "",
				checkList: [],
				tableData: {}, //选择商品列表信息
				currentRow: {}, //选中商品信息
			}
		},
		methods: {
			// 导出
			downloadFile() {

			},
			// 查询
			search() {
				this.page.pageNum=1
				this.getPromoGoodslist()
			},
			// 清空
			empty() {
				this.searchInfo = {}
			},
			// cloudShenhe(){
				
			// }
			// 查看详情
			seeDetail(id){
				this.dialogDatil = true
				this.$api.seeDatil(id).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.Datails = res.data
					}
				})
			},
			// 申请促销
			dialogChuxiao() {
				this.dialogChuciao = true
				this.currentRow.goodsName = ''
				this.currentRow.price = ''
			},
			//申请促销确定
			confirm() {
				console.log(this.currentRow.price,this.storeGoodsInfo.discountEndDatetime, this.storeGoodsInfo.discountStartDatetime);
				let data = {
					goodsId: this.currentRow.goodsId,
					goodsName: this.currentRow.goodsName,
					images: this.currentRow.images,
					price: this.currentRow.price,
					discountRate: this.storeGoodsInfo.discountRate,
					discountPrice: this.storeGoodsInfo.discountPrice,
					salesSum: this.storeGoodsInfo.stock,
					quantityLimit: this.storeGoodsInfo.quantityLimit,
					discountStartDatetime: this.storeGoodsInfo.discountStartDatetime,
					discountEndDatetime: this.storeGoodsInfo.discountEndDatetime,
					remark: this.storeGoodsInfo.remark
				}
				this.$api.addPromo(this.$encrypt(data)).then(res => {
					console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogChuciao = false
						this.getPromoGoodslist()
					}else{
						this.$message({
							message: res.message,
							type: 'waring'
						});
					}
				})
			},
			changePrice(e) {
				console.log(e);
				this.storeGoodsInfo.discountPrice = (this.currentRow.price * e).toFixed(2)
			},
			//去选择商品
			gotoXz() {
				this.innerVisible = true
				this.goodsearch = {}
				this.getXzgoodsList()
				
			},
			//去选择商品查询按钮
			onSubmit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					goodsName: this.goodsearch.goodsName,
					goodsId: this.goodsearch.goodsId
				}
				this.$api.promoGoodsList(data).then(res => {
					console.log(res);
					if (res.state == 'success') {
						this.tableData = res.data
						this.loading = false
					}
				})
			},
			//去选择商品确认按钮
			sure() {
				console.log(this.currentRow);
				this.innerVisible = false

			},
			// 去选择商品列表
			getXzgoodsList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}
				this.$api.promoGoodsList(data).then(res => {
					console.log(res);
					if (res.state == 'success') {
						this.tableData = res.data
						this.loading = false
					}
				})
			},
			// handleCurrentChange(val) {
			// 	console.log(val);
			//      this.currentRow = val;
			// },
			singleElection(row) {
				console.log(row);
				this.templateSelection = row.id
				this.currentRow = row
				console.log(this.currentRow)
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getPromoGoodslist()
				this.getXzgoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getPromoGoodslist()
				this.getXzgoodsList()
			},
			// 商品列表
			getPromoGoodslist() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}
				this.$api.promoExamile(this.$encrypt(data)).then(res => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.promtion = res.data
						this.loading = false
					}
				})
			},

		},
		created() {
			this.getPromoGoodslist()
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-input__inner{
		color: black !important;
	}
	/deep/.el-textarea__inner{
		color: black !important;
	}
</style>